import React, { useState, useEffect } from 'react';

export default function News({ api }) {
  const [news, setNews] = useState([]);
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [n, t] = await Promise.all([
          fetch(`${api}/api/news`).then(r => r.json()),
          fetch(`${api}/api/trending`).then(r => r.json()),
        ]);
        setNews(n);
        setTrending(t);
      } catch {}
      setLoading(false);
    };
    load();
    const interval = setInterval(load, 600000);
    return () => clearInterval(interval);
  }, [api]);

  if (loading) return <div className="loading"><div className="spinner" /><span>Loading news...</span></div>;

  const sourceColors = {
    'ESPN': '#ff0033',
    'FantasyPros': 'var(--accent)',
    'NFL.com': '#013369',
  };

  return (
    <div>
      <div className="page-header">
        <div className="page-title">News & Trends</div>
        <div className="page-subtitle">Latest fantasy news + waiver wire trending players</div>
      </div>

      {trending.length > 0 && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <span style={{ fontSize: '1.4rem' }}>🔥</span>
            <div className="card-title" style={{ margin: 0 }}>Trending Adds (24h)</div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 8 }}>
            {trending.map((p, i) => (
              <div key={i} style={{
                background: 'var(--bg3)',
                padding: '10px 12px',
                borderRadius: 6,
                border: '1px solid var(--border)',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
              }}>
                <div style={{
                  width: 30,
                  height: 30,
                  background: 'rgba(var(--accent2-rgb),0.15)',
                  color: 'var(--accent2)',
                  borderRadius: 4,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.7rem',
                  fontWeight: 700,
                  fontFamily: 'var(--font-mono)',
                  flexShrink: 0,
                }}>{p.position || '—'}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '0.85rem', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {p.name}
                    {p.injury_status && <span style={{ marginLeft: 6, fontSize: '0.65rem', color: 'var(--red)', fontWeight: 700 }}>{p.injury_status}</span>}
                  </div>
                  <div style={{ fontSize: '0.7rem', color: 'var(--text3)', fontFamily: 'var(--font-mono)' }}>
                    {p.team || 'FA'} · +{p.count.toLocaleString()} adds
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="card-title" style={{ marginBottom: 12, fontFamily: 'var(--font-display)', letterSpacing: 2 }}>
        📰 LATEST FANTASY NEWS
      </div>

      {news.length === 0 ? (
        <div className="empty-state">
          <p>News is loading. Check back in a moment.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {news.map((item, i) => (
            <a
              key={i}
              href={item.link}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'block',
                background: 'var(--bg2)',
                border: '1px solid var(--border)',
                borderRadius: 8,
                padding: 16,
                textDecoration: 'none',
                color: 'var(--text)',
                transition: 'all 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.transform = 'translateX(4px)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'translateX(0)'; }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <span style={{
                  fontSize: '0.65rem',
                  fontWeight: 700,
                  letterSpacing: 1.5,
                  color: sourceColors[item.source] || 'var(--accent)',
                  background: (sourceColors[item.source] || 'var(--accent)') + '15',
                  padding: '2px 8px',
                  borderRadius: 4,
                  fontFamily: 'var(--font-mono)',
                }}>
                  {item.source}
                </span>
                {item.date && (
                  <span style={{ fontSize: '0.7rem', color: 'var(--text3)', fontFamily: 'var(--font-mono)' }}>
                    {new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                  </span>
                )}
              </div>
              <div style={{ fontWeight: 600, fontSize: '0.95rem', marginBottom: 4 }}>
                {item.title}
              </div>
              {item.description && (
                <div style={{ fontSize: '0.82rem', color: 'var(--text2)', lineHeight: 1.5 }}>
                  {item.description.slice(0, 220)}{item.description.length > 220 ? '...' : ''}
                </div>
              )}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
